import { ROOT_URL } from 'Api';
import service from 'Api/service';

const routing = {
  fetchDrivers: () => {
    return service.get(
      import.meta.env.VITE_API_DOMAIN + '/api/location/drivers/names'
    );
  },
};

export default routing;
